export { default as YesNoModal } from './yesNoModal/YesNoModal'
export { default as EmptyModal } from './emptyModal/EmptyModal'
export {default as CoverModal} from './coverModal/CoverModal'
export const CM_COVER=Symbol('CM_COVER')
export const CM_CENTER_CENTER = Symbol('CM_CENTER_CENTER');
export const CM_TOP_LEFT = Symbol('CM_TOP_LEFT');
export const CM_TOP_CENTER = Symbol('CM_TOP_CENTER');
export const CM_TOP_RIGHT = Symbol('CM_TOP_RIGHT');
